// extracted by mini-css-extract-plugin
export default {"root":"BookingsHistory_root__MH0aI"};